import React from 'react';
import { Tooltip, NavigationHeadIcon } from '../../index';

export const NavigationHeadCollapsed = ({
    active, // nav head accordion menu is open
    className,
    disabled,
    icon,
    index,
    label,
    onClick = () => { }
}) => {

    const iconColor = (active) ? '$color-primary-a3' : '$color-secondary-a2';

    const navHeaderClasses = [
        `bsw-navigation__header--collapsed`,
        `${disabled ? 'bsw-navigation__header--collapsed-disabled' : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <button
            data-container="MenuHeadItem"
            className={navHeaderClasses}
            disabled={disabled}
            onClick={onClick}
            type="button"
            aria-label={`Expand ${label}`}
            role="listitem"
        >
            <Tooltip
                text={label}
                tooltipId={`bsw-navigation__header-tooltip-${index}`}
                placement={"right"}
            >
                <div className="tooltip-box"></div>
            </Tooltip>
            <NavigationHeadIcon
                icon={icon}
                color={iconColor}
                disabled={disabled}
            />
        </button>
    );

}
